import { render } from "./SuperAdminTariffActions.vue?vue&type=template&id=fb977b84"
import script from "./SuperAdminTariffActions.vue?vue&type=script&lang=js"
export * from "./SuperAdminTariffActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__